import * as React from 'react';
import { Container } from 'reactstrap';
import { Fabric } from 'office-ui-fabric-react';

import { signalRService } from '../Services/SignalRService';
import { securityService } from '@app/Services/SecurityService';

import { Loading } from './Loading';
import { NavMenu } from './NavMenu';
import { Modals } from './Modal';

export type LayoutProps = {
    children?: React.ReactNode;
};

export class Layout extends React.Component<LayoutProps, {}> {

    constructor(props: LayoutProps) {
        super(props);
        signalRService.initialize();
        securityService.loadPermissions();
    }
    
    public render() {
        return (
            <Fabric className="content-wrapper" key="wrapper">
                <NavMenu />
                <Container fluid>
                    {this.props.children}
                </Container>
                <Loading fullpage />
                <Modals />
            </Fabric>
        );
    }
}
